import '@babel/polyfill'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue'
import vSelect from 'vue-select'
import Vuebar from 'vuebar';
import {Datepicker, Timepicker, DatetimePicker} from '@livelybone/vue-datepicker';

import 'vue-select/dist/vue-select.css';
import '@livelybone/vue-datepicker/lib/css/index.css';

Vue.use(Vuebar);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.component('datepicker', Datepicker);
Vue.component('timepicker', Timepicker);
Vue.component('vueselect', vSelect);
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.$web_protocol = process.env.VUE_WEB_PROTOCOL;

Vue.mixin({
  methods: {

    storeDataInStorage(name, data){

      const dataToStore = JSON.stringify(data);
      localStorage.setItem(name, dataToStore);

    },

    getDataFromStorage(name){

      return JSON.parse(localStorage.getItem(name));

    },

    clearStorage(name){

      if(name){

        localStorage.removeItem(name);
        return;

      }
      
      localStorage.clear();

    },

    setCookie(name,value,days) {
      let expires = "";
      if (days) {
          let date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },

    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },

    eraseCookie(name) {   
        document.cookie = name+'=; Max-Age=-99999999;';  
    },
    
  },
 
});

let handleOutsideClick;
Vue.directive('closable', {
  bind (el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName]
          // See if this excluded element
          // is the same element the user just clicked on
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

new Vue({
  render: h => h(App),
}).$mount('#app')
